import { DealEntity } from '@lib/deals';
import vest, { enforce, test } from 'vest';

export const QPValidationSuite = vest.create(companymapping => {
  //console.log(companymapping, 'companymapping validation');
  test('Mandatory', 'Either Company or Person is required.', () => {
    const hasCompany = Boolean(companymapping?.buyers?.[0]?.vtr_id);

    const personArray = (
      (companymapping?.associated_person as Array<Partial<DealEntity>>) || []
    ).filter(p => p?.vtr_id);

    const hasPerson = personArray.length > 0;

    enforce(hasCompany || hasPerson).isTruthy();
  });
 test('Mandatory', 'Designation is required.', () => {
  const hasPerson =
    Array.isArray(companymapping?.associated_person) &&
    companymapping.associated_person.some(p => p?.vtr_id);

  // If no person exists, do not enforce designation
  if (!hasPerson) return;

  // If person exists, designation must be present
  enforce(companymapping.associated_person[0]?.designation).isTruthy();
});
  test('Mandatory', 'Statement Type is required.', () => {
    enforce(companymapping?.statement_type).isTruthy();
  });
  test('Mandatory', 'Statement is required.', () => {
    enforce(companymapping?.statement).isTruthy();
  });
  test('Mandatory', 'Statement Date is required.', () => {
    enforce(companymapping?.statement_date).isTruthy();
  });
  test('Source URL', 'Please enter valid source URLs.', () => {
    const sourceUrls = companymapping?.source_urls || [];

    // Don't validate when there are no source URLs
    if (!Array.isArray(sourceUrls) || sourceUrls.length === 0) {
      return;
    }

    sourceUrls.forEach(url => {
      // Ignore empty URLs if they are optional
      if (!url?.trim()) {
        return;
      }

      enforce(isValidHttpUrl(url)).isTruthy();
    });
  });
});

const isValidHttpUrl = (value: string): boolean => {
  try {
    const url = new URL(value.trim());

    return url.protocol === 'http:' || url.protocol === 'https:';
  } catch {
    return false;
  }
};
